/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SearchAllShiftsRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {SearchAllShiftsResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const searchAllShifts = (request: SearchAllShiftsRequest, options?: CashRequestOptions) => post<SearchAllShiftsRequest, SearchAllShiftsResponse>("/proxy/services/squareup.timecards.TimeCalculationReportService/SearchAllShifts", request, {...options, rejectOnError: true })